import React, { useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { isMobile } from 'react-device-detect';
import SelectCities from '../../../../../components/FormInputs/SelectCities';
import { store } from './reducer';
import FleetsTextFields from 'components/TextFields/FleetsTextFields';
import DatePicker from '../../../../../components/TextFields/DatePicker';
import { Checkbox, FormControlLabel, FormGroup } from '@material-ui/core';
import { useSearchParams } from 'hooks/useSearchParams';
import { useCalculation } from 'useStores/useCalculation';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'grid',
    gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 1fr 1fr 1fr 1fr',
    gridGap: theme.spacing(1),
  },
}));

const Filters = () => {
  const classes = useStyles();

  const origin = useCalculation((state) => state.filters.origin);
  const setOrigin = useCalculation((state) => state.setOrigin);

  const destination = useCalculation((state) => state.filters.destination);
  const setDestination = useCalculation((state) => state.setDestination);

  const fleetOptions = useCalculation((state) => state.filters.fleetOptions);
  const setFleetOptions = useCalculation((state) => state.setFleetOptions);

  const fromDate = useCalculation((state) => state.filters.fromDate);
  const setFromDate = useCalculation((state) => state.setFromDate);

  const toDate = useCalculation((state) => state.filters.toDate);
  const setToDate = useCalculation((state) => state.setToDate);

  const progress = useCalculation((state) => state.filters.progress);
  const setProgress = useCalculation((state) => state.setProgress);

  const isPreviuseOrders = useCalculation(
    (state) => state.filters.isPreviuseOrders
  );
  const setIsPreviuseOrder = useCalculation(
    (state) => state.setIsPreviuseOrder
  );

  const reset = useCalculation((state) => state.reset);

  const handleChangeOrigin = (city) => {
    setOrigin(city);
  };
  const handleChangeDestination = (city) => {
    setDestination(city);
  };
  const handleChangeFleetOptions = (fleetOptions) => {
    setFleetOptions(fleetOptions);
  };
  const handleChangeFromDate = (date) => {
    setFromDate(date);
  };
  const handleChangeToDate = (date) => {
    setToDate(date);
  };

  const handleChangeLegal = (e) => {
    const { checked, name } = e.target;
    setIsPreviuseOrder(checked);
  };

  useEffect(() => {
    return () => reset();
  }, []);

  return (
    <div className={classes.root}>
      <SelectCities
        isMulti={false}
        placeholder="شهر مبدا"
        city={origin}
        isDest={false}
        onSelect={handleChangeOrigin}
        hasLabel
      />
      <SelectCities
        isMulti={false}
        placeholder="شهر مقصد"
        city={destination}
        onSelect={handleChangeDestination}
        hasLabel
      />
      <FleetsTextFields
        single
        onChange={handleChangeFleetOptions}
        selection={fleetOptions}
        title="نوع ناوگان"
      />
      <DatePicker
        label="از تاریخ"
        value={fromDate}
        onChange={handleChangeFromDate}
        size="large"
      />
      <DatePicker
        label="تا تاریخ"
        value={toDate}
        onChange={handleChangeToDate}
        size="large"
      />
      <FormGroup row>
        <FormControlLabel
          control={
            <Checkbox
              name="previuseOrders"
              onChange={handleChangeLegal}
              checked={isPreviuseOrders}
              defaultChecked
            />
          }
          label="برمبنای سفارشات پیشین"
        />
      </FormGroup>
    </div>
  );
};

export default Filters;
